module.exports = __webpack_public_path__ + "img/r10-25.a4cb0799.png";